export const regions = [
  { value: 1, title: "Hovedstaden" },
  { value: 2, title: "Sjælland" },
  { value: 3, title: "Syddanmark" },
  { value: 4, title: "Midtjylland" },
  { value: 5, title: "Nordjylland" },
];

export const regionsMap = new Map<string, string>(
  regions.map((region) => [region.value.toString(), region.title]),
);
